import Pubnub from 'pubnub';

let connection;
let connectedChannels = {};

const messageSubscriptons = new Set();

export const connect = (pubnubId?: string, subscribeKey?: string) => {
    if (connection) {
        return connection;
    }

    connection = new Promise<any>((resolve, reject) => {
        const options = {
            restore: true,
            subscribeKey,
            uuid: pubnubId,
        };

        const pubnub = new Pubnub(options);

        const initialHandler = {
            status: (statusEvent) => {
                switch (statusEvent.category) {
                    case 'PNConnectedCategory':
                    case 'PNNetworkUpCategory':
                        resolve(pubnub);
                        break;
                    case 'PNDisconnectedCategory':
                    case 'PNNetworkDownCategory':
                        reject(new Error('Received a network-down message'));
                        break;
                    default:
                        return;
                }

                pubnub.removeListener(initialHandler);

                pubnub.addListener({
                    message: function () {
                        // @ts-ignore
                        messageSubscriptons.forEach((handler) => handler.apply(undefined, arguments));
                    },
                });
            },
        };

        pubnub.addListener(initialHandler);

        return handshake(pubnub)
            .then(() => resolve({ pubnub, uuid: pubnubId }))
            .catch(reject);
    });

    return connection;
};

export const disconnect = () =>
    connect().then(({ pubnub }) => {
        if (pubnub) {
            pubnub.stop();
        }
    });

const handshake = (pubnub) =>
    new Promise((resolve, reject) => {
        pubnub.time((status) => {
            if (status.error) {
                reject(new Error(`Pubnub service failed to respond to time request: ${status}`));
            } else {
                resolve(pubnub);
            }
        });
    });

const isConnected = (channel) => Boolean(connectedChannels[channel]);

export const subscribe = (channel: string, messageHandler: Function, sessionId: string, subscribeKey: string) => {
    if (isConnected(channel)) {
        connectedChannels[channel] += 1;
    } else {
        connectedChannels[channel] = 1;
    }

    messageSubscriptons.add(messageHandler);

    connect(sessionId, subscribeKey).then(({ pubnub }) => {
        if (pubnub) {
            pubnub.subscribe({
                channels: [channel],
                withPresence: false,
            });
        }
    });

    return {
        channel,
        unsubscribe: () => {
            connectedChannels[channel] -= 1;
            messageSubscriptons.delete(messageHandler);

            return connect(sessionId, subscribeKey).then(({ pubnub }) => {
                if (pubnub) {
                    pubnub.unsubscribe({ channels: [channel] });
                }
            });
        },
    };
};
